<script setup lang="ts">
const items = [
  {
    title: 'Akses Dana Lebih Awal',
    description:
      'Dapatkan hingga 50% dari nilai barang per pengiriman sebelum paket diterima.',
    icon: 'material-symbols:history-toggle-off'
  },
  {
    title: 'Cashflow Tetap Lancar',
    description:
      'Gunakan dana tersebut untuk menjaga kelancaran stok, produksi, dan aktivitas marketing.',
    icon: 'ic:outline-payments'
  },
  {
    title: 'Keamanan Terjamin',
    description:
      'Setiap pencairan dilakukan melalui sistem verifikasi KiriminAja yang transparan dan terintegrasi.',
    icon: 'ic:outline-gpp-good'
  }
]
</script>

<template>
  <section class="bg-surface-container-low dark:bg-surface-container-highest">
    <UiContainer class="py-12 flex flex-col gap-6 lg:gap-16">
      <UiSectionTitle
        class="text-center"
        title="COD Advance Strategi Cerdas Mengelola Cashflow Bisnis Besar"
      />

      <div class="flex flex-col gap-6">
        <div class="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <UiCardFeature
            v-for="(item, key) in items"
            :key="key"
            :icon="item.icon"
            icon-size="32px"
            :title="item.title"
            :description="item.description"
          />
        </div>
        <UiButton
          class="sm:self-center"
          :to="
            $utm.utmUrl('/login', {
              redirectTo: '/cod-advance'
            })
          "
          label="Ajukan COD Advance"
        />
      </div>
    </UiContainer>
  </section>
</template>
